var $2b6e161c9edcf319$exports = {};
const $2b6e161c9edcf319$var$addButton = document.querySelector(".add--js");
const $2b6e161c9edcf319$var$subtractButton = document.querySelector(".subtract--js");
const $2b6e161c9edcf319$var$counterValue = document.querySelector(".counter--js");
let $2b6e161c9edcf319$var$glasses = 0;
let $2b6e161c9edcf319$var$key = new Date().toLocaleString().slice(0, 10);
setInterval(()=>{
    console.log("tik-tak");
    if ($2b6e161c9edcf319$var$key !== new Date().toLocaleString().slice(0, 10)) {
        $2b6e161c9edcf319$var$key = new Date().toLocaleString().slice(0, 10);
        $2b6e161c9edcf319$var$setCounterValue(0);
        $2b6e161c9edcf319$var$glasses = 0;
    }
}, 60000);
if (localStorage.getItem($2b6e161c9edcf319$var$key)) $2b6e161c9edcf319$var$glasses = parseInt(localStorage.getItem($2b6e161c9edcf319$var$key));
const $2b6e161c9edcf319$var$setCounterValue = (value)=>{
    $2b6e161c9edcf319$var$counterValue.innerHTML = value;
    localStorage.setItem($2b6e161c9edcf319$var$key, value);
};
$2b6e161c9edcf319$var$setCounterValue($2b6e161c9edcf319$var$glasses);
$2b6e161c9edcf319$var$addButton.addEventListener("click", ()=>{
    $2b6e161c9edcf319$var$glasses = $2b6e161c9edcf319$var$glasses + 1;
    $2b6e161c9edcf319$var$setCounterValue($2b6e161c9edcf319$var$glasses);
});
$2b6e161c9edcf319$var$subtractButton.addEventListener("click", ()=>{
    if ($2b6e161c9edcf319$var$glasses >= 1) {
        $2b6e161c9edcf319$var$glasses = $2b6e161c9edcf319$var$glasses - 1;
        $2b6e161c9edcf319$var$setCounterValue($2b6e161c9edcf319$var$glasses);
    }
});


//# sourceMappingURL=index.0aed9f2b.js.map
